'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import TrialActivationNextStepsModal from './TrialActivationNextStepsModal';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import { NEXT_STEPS_SURVEY_UPGRADE_PRODUCTS } from 'ui-addon-upgrades/_core/common/constants/trials';
import { navigateTo } from '../../common/navigation/url';
import { getTrialGuideUrl } from '../../utils/links';
import { refresh } from '../../utils/links';
import { trialIdsWithTrialGuide, upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
const SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY'
};

const TrialActivationSuccessContainer = ({
  hideBackground,
  header,
  subText,
  ctaText,
  onSuccess,
  upgradeData,
  shouldHideSurvey,
  showIllustration,
  showTrialLoadingState
}) => {
  const {
    upgradeProduct,
    app,
    screen,
    uniqueId
  } = upgradeData;
  const [successModalType, setSuccessModalType] = useState(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);
  const defaultOnSuccess = useCallback(() => {
    const trialId = upgradeProductToTrialIds[upgradeProduct];

    if (trialIdsWithTrialGuide.includes(trialId)) {
      navigateTo(getTrialGuideUrl(upgradeProduct, `${app}-${screen}-${uniqueId}`));
    } else {
      refresh();
    }
  }, [app, screen, uniqueId, upgradeProduct]);

  const maybeShowNextStepsSurvey = () => {
    const shouldShowNextStepsSurvey = NEXT_STEPS_SURVEY_UPGRADE_PRODUCTS.includes(upgradeProduct) && !shouldHideSurvey;

    if (shouldShowNextStepsSurvey) {
      return setSuccessModalType(SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY);
    }

    if (onSuccess) {
      return onSuccess();
    }

    return defaultOnSuccess();
  };

  switch (successModalType) {
    case SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY:
      return /*#__PURE__*/_jsx(TrialActivationNextStepsModal, {
        upgradeData: upgradeData
      });

    case SUCCESS_MODAL_TYPES.INITIAL_SUCCESS:
      return /*#__PURE__*/_jsx(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        hideBackground: hideBackground,
        header: header,
        subText: subText,
        ctaText: ctaText,
        showIllustration: showIllustration,
        showTrialLoadingState: showTrialLoadingState,
        onSuccess: maybeShowNextStepsSurvey,
        upgradeData: upgradeData
      });

    default:
      return null;
  }
};

TrialActivationSuccessContainer.propTypes = Object.assign({
  hideBackground: PropTypes.bool.isRequired,
  header: PropTypes.node,
  subText: PropTypes.node,
  ctaText: PropTypes.node,
  showIllustration: PropTypes.bool,
  shouldHideSurvey: PropTypes.bool,
  onSuccess: PropTypes.func,
  showTrialLoadingState: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationSuccessContainer;